module.exports = __webpack_public_path__ + "img/huaweicloud.582d5824.svg";